var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expansion-footer"},[_c('v-btn',{staticClass:"mr-4",attrs:{"depressed":"","color":"white"},on:{"click":_vm.goBack}},[_vm._v("Cancel")]),_c('PrimaryButton',{attrs:{"loading":_vm.loading,"disabled":_vm.cansave},on:{"handleClick":_vm.saveInfo}},[_vm._v(" Save ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }